// Angular
import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
// Module
import { ComponentFactoryResolverService, RoleGuard } from '@cv-invision/core';
// Components
import {InboxComponent} from './inbox/inbox.component';
import {CreateOrderComponent} from './create-order/create-order.component';
import {ImportOrderComponent} from './import-order/import-order.component';
import { InboxHeaderComponent } from './inbox/header/inbox-header.component';
import { IntelligenceComponent } from "./intelligence.component";

const routes: Routes = [
	{
		path: '',
		canActivate: [RoleGuard],
		component: IntelligenceComponent,
		resolve: {
			componentFactoryResolver: ComponentFactoryResolverService
		},
		data: {
			module: 'intelligence'
		},
		children: [
			{
				path: '',
				data: {
					breadcrumbComponent: InboxHeaderComponent
				},
				redirectTo: 'inbox',
				pathMatch: 'prefix'
			},
			// {
			// 	path: 'dashboard', component: DashboardComponent,
			// 	data: {
			// 		subComponentShow: false
			// 	}
			// },
			{
				path: 'inbox', component: InboxComponent,
				data: {
					breadcrumbComponent: InboxHeaderComponent
				}
			},
			{
				path: 'create', component: CreateOrderComponent,
				data: {
					subComponentShow: false
				}
			},
			{
				path: 'import', component: ImportOrderComponent,
				data: {
					subComponentShow: false
				}
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class IntelligenceRoutingModule {
}
